import { createContext, ReactNode, useState } from "react";
import Turnstile from "react-turnstile";

//llamar provider
export const TurnstileContext = createContext({ sitekey: "", widgetId: "" });

type Props = {
    sitekey: string;
    children: ReactNode
};
export const TurnstileProvider = ({ sitekey, children }: Props) => {

    const [widgetId, setWidgetId] = useState('');



    return (<TurnstileContext.Provider value={{ sitekey, widgetId }}>
        {children}
        <Turnstile
            sitekey={sitekey}
            refreshExpired={'manual'}
            onLoad={async (widgetIdTrn, bound) => { setWidgetId(widgetIdTrn); }}
            id={'turnStileTkncontainer'}
            theme={'light'}
            style={{ 'display': 'none' }}
        />
    </TurnstileContext.Provider>)

}